var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plantuml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 265.86 310.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#ccc;}.cls-4{fill:#991039;}.cls-5{fill:#0466a4;}.cls-6{fill:#ffba39;}.cls-7{fill:#16003a;}.cls-8{fill:#666;}.cls-9{fill:#e62c2d;}.cls-10{fill:#fff;}.cls-11{fill:#b2b2b2;}.cls-12{fill:#a8a8a8;}.cls-13{fill:#adadad;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "161.3 211.73 170.51 88.76 174.51 88.76 177.51 223.76 161.51 223.76 161.3 211.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.84 88.11 162.84 90.31 157.89 89.09 84.16 103.86 89.07 106.08 163.57 96.35 165.7 93.44 170.83 90.67 170.84 88.11"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "171.41 89.7 178.94 93.2 181.92 97.34 247.68 133.8 245.37 128.93 182.29 88.13 178.78 88.97 173.07 87.76 171.41 89.7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.51 88.76 169.51 219.76 176.51 219.76 173.51 88.76"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.34 87.32 175.46 79.1 178.52 75.02 193.88 1.42 189.91 5.06 169.62 77.4 171.46 80.5 172 86.31 174.34 87.32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.5,
    y: 73.5,
    width: 8,
    height: 8,
    transform: "translate(81.29 -112.06) rotate(45)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "factory"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.01 206.26 122.01 249.26 70.01 278.26 1.01 234.26 54.01 206.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "68.51 309.76 69.51 277.76 1.51 234.76 0.51 267.76 68.51 309.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.82 223.22 113.51 206.76 180.51 249.76 128.51 278.76 121.51 249.76 80.82 223.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "139.42 223.39 172.51 205.76 239.51 247.76 187.28 278.76 180.51 249.76 139.42 223.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "239.51 247.76 239.51 178.76 209.51 159.76 210.81 229.77 239.51 247.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "209.51 159.76 231.51 147.76 260.51 165.76 239.62 180.07 209.51 159.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "236.51 139.76 231.51 138.76 221.51 125.76 222.51 111.76 229.51 103.76 236.51 99.76 242.51 94.76 245.51 88.76 248.51 85.76 249.51 74.76 252.51 77.76 252.51 89.76 244.51 100.76 234.51 108.76 229.51 114.76 228.51 121.76 230.51 127.76 236.51 137.76 236.51 139.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "243.51 144.76 249.51 140.76 251.51 128.76 246.51 121.76 245.51 113.76 255.51 106.76 264.51 101.76 256.51 99.76 247.51 105.76 240.51 111.76 236.51 117.76 236.51 125.76 238.51 130.76 242.51 132.76 244.51 136.76 245.51 140.76 243.51 144.76 243.51 144.76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wall"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "white",
    className: "cls-10",
    points: "68.51 309.76 261.51 309.76 260.51 165.76 239.51 178.76 239.51 247.76 187.51 279.76 180.51 249.76 128.51 278.76 121.51 249.76 69.51 278.76 68.51 309.76"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "window-l",
    className: "cls-11",
    x: 99.51,
    y: 278.76,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "window-m",
    className: "cls-12",
    x: 157.51,
    y: 278.76,
    width: 12,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "window-r",
    className: "cls-13",
    points: "216.51 278.76 216.51 289.76 228.51 290.76 228.51 277.76 216.51 278.76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFact);
export default __webpack_public_path__ + "static/media/fact.ec5f092929108f70936bb069dbcb546e.svg";
export { ForwardRef as ReactComponent };